<template>
    <div>
        <CRow>
            <CCol sm="3">
                <label class="col-form-label">Primary Category</label>
            </CCol>
            <CCol sm="3">
                <label class="col-form-label">Secondary Category</label>
            </CCol>
            <CCol sm="2">
                <label class="col-form-label">Sub Category</label>
            </CCol>
            <CCol sm="1">
                <label class="col-form-label">Allocation</label>
                <div v-if="allocationError" class="text-danger">
                    {{ allocationError }}
                </div>
            </CCol>
            <CCol sm="1">
                <label class="col-form-label">Spend</label>
            </CCol>
        </CRow>
        <CRow v-for="(el, index) in vendorAllocationList" :key="index">
            <CCol sm="3">
                <CSelect
                    placeholder="Select a prime category"
                    :value="$v.vendorAllocationList.$each[index].primeCategory.$model"
                    :options="categoryList[index].primeCategoryOptions"
                    invalidFeedback="Select a valid prime category"
                    :id="`prime-category-${index}`"
                    @input="value => {
                        $v.vendorAllocationList.$each[index].primeCategory.$model = parseInt(value);
                        handlePrimeSelect(el, index);
                    }"
                />
            </CCol>
            <CCol sm="3">
                <CSelect
                    placeholder="Select a secondary category"
                    :value="$v.vendorAllocationList.$each[index].secondaryCategory.$model"
                    :options="categoryList[index].secondaryCategoryOptions"
                    :disabled="!categoryList[index].secondaryCategoryOptions.length"
                    invalidFeedback="Select a valid secondary category"
                    :id="`secondary-category-${index}`"
                    @input="value => {
                        $v.vendorAllocationList.$each[index].secondaryCategory.$model = parseInt(value);
                        handleSecondarySelect(el, index);
                    }"
                />
            </CCol>
            <CCol sm="2">
                <CSelect
                    placeholder="Select a sub category"
                    :value="$v.vendorAllocationList.$each[index].subCategory.$model"
                    :options="categoryList[index].subCategoryOptions"
                    :disabled="!categoryList[index].subCategoryOptions.length"
                    invalidFeedback="Select a valid sub category"
                    :id="`sub-category-${index}`"
                    @input="value => {
                        $v.vendorAllocationList.$each[index].subCategory.$model = parseInt(value);
                        subCategoryChanged = true;
                    }"
                />
            </CCol>
            <CCol sm="1">
                <CInput
                    placeholder="Allocation"
                    :value="$v.vendorAllocationList.$each[index].allocation.$model"
                    @input="value => {
                        $v.vendorAllocationList.$each[index].allocation.$model = value;
                        handleAllocationChange(index);
                    }"
                />
            </CCol>
            <CCol sm="1">
                <p class="text-left pt-2">{{ $v.vendorAllocationList.$each[index].total_spend.$model }}</p>
            </CCol>
            <CCol sm="1">
                <CButton
                    v-if="vendorAllocationList.length > 1 || totalAllocation === 100"
                    @click="deleteAllocation(index)"
                    style="background: #f6f8fb"
                >
                    <i class="fas fa-minus" style="color: #000"></i>
                </CButton>
            </CCol>
            <CCol sm="1">
                <CButton
                    v-if="index + 1 === vendorAllocationList.length"
                    @click="addAllocation"
                    style="background: #1b704d"
                >
                    <i class="fas fa-plus" style="color: #fff"></i>
                </CButton>
            </CCol>
        </CRow>

        <Error
            :modal="error.enable"
            :message="error.message"
            @close="error.enable = false"
        />
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import {
    GET_PRIME_CATEGORIES,
    GET_SECONDARY_CATEGORIES,
    GET_SUB_CATEGORIES,
} from "../vendorQueries";

export default {
    name: "vendor_allocation",
    props: {
        vendorAllocation: {
            type: Array,
            required: true,
            default: () => []
        },
        vendorTotalSpend: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            vendorAllocationList: [],
            categoryList: [],
            totalAllocation: 0,
            deletedVendorAllocation: [],
            error: { enable: false, message: "", color: "danger" },
            primeCategories: [],
            secondaryCategories: [],
            subCategories: [],
            subCategoryChanged: false,
            allocationError: "",
        };
    },
    watch: {
        vendorAllocation: {
            immediate: true,
            handler(newVal) {
                if (newVal?.length) {
                    this.vendorAllocationList = [];
                    this.categoryList = [];
                    this.initializeData();
                }
            }
        }
    },
    methods: {
        handleAllocationChange(index) {

            let totalAllocation = 0;
            let wrongAllocated = false;
            this.vendorAllocationList.forEach((item) => {
                totalAllocation += parseFloat(item.allocation) || 0;
            });

            if (totalAllocation != 100) {
                this.allocationError = totalAllocation + "%";
                wrongAllocated = true;
                this.$v.vendorAllocationList.$each[index].total_spend.$model = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(((100 - totalOtherAllocations) / 100) * vendorTotal);
                this.calculateTotalAllocation();
                return;
             }  else {
                this.allocationError = "";
            }
            
            if (!wrongAllocated) {
                this.vendorAllocationList.forEach((item, index) => {
                    const vendorTotal = parseFloat(this.vendorTotalSpend.replace(/[$,]/g, ''));
                    const spendAmount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((parseFloat(item.allocation) || 0) / 100 * vendorTotal);
                    this.vendorAllocationList[index].total_spend = spendAmount;
                });
            }
            this.calculateTotalAllocation();


    
            let totalOtherAllocations = 0;
            const vendorTotal = parseFloat(this.vendorTotalSpend.replace(/[$,]/g, ''));

            this.vendorAllocationList.forEach((item, i) => {
                if (i !== index && item.allocation) {
                    totalOtherAllocations += parseFloat(item.allocation);
                }
            });

         

        },

        async fetchPrimeCategories() {
            const { data } = await this.$apollo.query({ query: GET_PRIME_CATEGORIES });
            this.primeCategories = data.spendmd_db_prime_categories;
        },

        async fetchSecondaryCategories(primeCategoryId) {
            if (!primeCategoryId) {
                this.secondaryCategories = [];
                return;
            }

            const { data } = await this.$apollo.query({
                query: GET_SECONDARY_CATEGORIES,
                variables: { primary_category_id: parseInt(primeCategoryId) },
            });
            this.secondaryCategories = data.spendmd_db_secondary_categories;
        },

        async fetchSubCategories(secondaryCategoryId) {
            if (!secondaryCategoryId) {
                this.subCategories = [];
                return;
            }

            const { data } = await this.$apollo.query({
                query: GET_SUB_CATEGORIES,
                variables: { secondary_category_id: parseInt(secondaryCategoryId) },
            });
            this.subCategories = data.spendmd_db_sub_categories;
        },

        getEachVendorAllocationList() {
            return {
                primeCategory: null,
                secondaryCategory: null,
                subCategory: null,
                allocation: 0,
                total: null,
            };
        },

        getEachCategoryOptions() {
            return {
                primeCategoryOptions: [],
                secondaryCategoryOptions: [],
                subCategoryOptions: [],
            };
        },

        async handlePrimeSelect(allocation, index) {
            this.categoryList[index].secondaryCategoryOptions = [];
            this.categoryList[index].subCategoryOptions = [];

            if (allocation.primeCategory) {
                await this.fetchSecondaryCategories(allocation.primeCategory);
                this.categoryList[index].secondaryCategoryOptions = this.secondaryCategories.map(category => ({
                    label: category.name,
                    value: category.id,
                }));
            }

            if (document.getElementById(`secondary-category-${index}`)) {
                document.getElementById(`secondary-category-${index}`).selectedIndex = 0;
            }
            if (document.getElementById(`sub-category-${index}`)) {
                document.getElementById(`sub-category-${index}`).selectedIndex = 0;
            }

            this.$v.vendorAllocationList.$each[index].secondaryCategory.$reset();
            this.$v.vendorAllocationList.$each[index].subCategory.$reset();
        },

        async handleSecondarySelect(allocation, index) {
            this.categoryList[index].subCategoryOptions = [];

            if (allocation.secondaryCategory) {
                await this.fetchSubCategories(allocation.secondaryCategory);
                this.categoryList[index].subCategoryOptions = this.subCategories.map(category => ({
                    label: category.name,
                    value: category.id,
                }));
            }

            if (document.getElementById(`sub-category-${index}`)) {
                document.getElementById(`sub-category-${index}`).selectedIndex = 0;
            }

            this.$v.vendorAllocationList.$each[index].subCategory.$reset();
        },

        calculateTotalAllocation() {
            this.totalAllocation = this.vendorAllocationList.reduce(
                (sum, el) => sum + Number(el.allocation),
                0
            );
            return this.totalAllocation;
        },

        addAllocation() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.calculateTotalAllocation();
            if (this.totalAllocation === 100) {
                this.error = {
                    enable: true,
                    message: "Total allocation already reached 100%",
                    color: "warning",
                };
                return;
            }

            if (this.vendorAllocationList.length === 10) {
                this.error = {
                    enable: true,
                    message: "Maximum 10 allocations per vendor",
                    color: "warning",
                };
                return;
            }

            this.vendorAllocationList.push(this.getEachVendorAllocationList());
            this.categoryList.push({
                ...this.getEachCategoryOptions(),
                primeCategoryOptions: this.primeCategories.map(category => ({
                    label: category.name,
                    value: category.id,
                }))
            });

            console.log("this.vendorAllocationList-add", this.vendorAllocationList);
        },

        deleteAllocation(index) {
            if (this.$route.path.includes("edit") && this.vendorAllocationList[index].id) {
                this.deletedVendorAllocation.push(parseInt(this.vendorAllocationList[index].id));
            }

            this.vendorAllocationList.splice(index, 1);
            this.categoryList.splice(index, 1);

            this.calculateTotalAllocation();
            if (this.totalAllocation === 0) {
                this.categoryList.push({
                    ...this.getEachCategoryOptions(),
                    primeCategoryOptions: this.primeCategories.map(category => ({
                        label: category.name,
                        value: category.id,
                    }))
                });
                this.vendorAllocationList.push(this.getEachVendorAllocationList());
                this.$v.$reset();
                if (document.getElementById("prime-category-0")) {
                    document.getElementById("prime-category-0").selectedIndex = 0;
                }
            }
        },

        getVendorAllocations() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                console.log("this.vendorAllocationList", this.vendorAllocationList);

                const vendorAllocations = this.vendorAllocationList.map(el => ({
                    prime_category: parseInt(el.primeCategory),
                    category: parseInt(el.secondaryCategory),
                    sub_category: parseInt(el.subCategory),
                    allocation: parseFloat(el.allocation),
                    total_spend: el.total_spend,
                    id: el.id ? parseInt(el.id) : null,
                }));

                const totalAllocation = this.calculateTotalAllocation();

                console.log("vendorAllocations", vendorAllocations);
                console.log("totalAllocation", totalAllocation);

                return { vendorAllocations, totalAllocation };
            }
            return { vendorAllocations: null, totalAllocation: null };
        },

        async setVendorAllocationList(vendorAllocations) {
            for (const [index, el] of vendorAllocations.entries()) {
                const allocation = {
                    primeCategory: parseInt(el.prime_category_id),
                    secondaryCategory: parseInt(el.secondary_category_id),
                    subCategory: parseInt(el.sub_category_id),
                    allocation: ((parseFloat(el.total_spend.replace(/[$,]/g, ''))/parseFloat(this.vendorTotalSpend.replace(/[$,]/g, '')))*100).toFixed(2),
                    total_spend: el.total_spend,
                    id: parseInt(el.id),
                };
                this.vendorAllocationList.push(allocation);
                await this.handlePrimeSelect(allocation, index);
                await this.handleSecondarySelect(allocation, index);
            }
        },

        async initializeData() {
            await this.fetchPrimeCategories();
            if (this.$route.path.includes("edit") && this.vendorAllocation.length) {
                this.categoryList = this.vendorAllocation.map(() => ({
                    ...this.getEachCategoryOptions(),
                    primeCategoryOptions: this.primeCategories.map(category => ({
                        label: category.name,
                        value: category.id,
                    })),
                }));
                await this.setVendorAllocationList([...this.vendorAllocation]);
            } else {
                this.categoryList.push({
                    ...this.getEachCategoryOptions(),
                    primeCategoryOptions: this.primeCategories.map(category => ({
                        label: category.name,
                        value: category.id,
                    }))
                });
                this.vendorAllocationList.push(this.getEachVendorAllocationList());
            }
        }
    },
    async created() {
        await this.initializeData();
    },
    mixins: [validationMixin],
    validations: {
        vendorAllocationList: {
            $each: {
                primeCategory: { required },
                secondaryCategory: {},
                subCategory: {},
                allocation: { required },
                total_spend: { required },
            },
        },
    },
};
</script>
